import { useCurrentSpaceContext } from "@circle-react/contexts/currentSpaceContext";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import copyToClipboard from "copy-to-clipboard";
import { useEffect, useState } from "react";

import { t } from "@/i18n-js/instance";
import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";
import { postsPath } from "@/react/helpers/urlHelpers";

export const usePostShareOptions = ({
  post,
  getSharePostLink,
  sharePostData,
}) => {
  const { success } = useToast();
  const { currentCommunity } = usePunditUserContext();
  const { data: currentSpace } = useCurrentSpaceContext();

  const [formData, setFormData] = useState({
    post: {
      show_post_teaser: !!post?.show_post_teaser,
      share_to_web: !!post?.share_post_enabled,
      share_post_enabled: !!post?.share_post_enabled,
      minimal_layout: !!post?.minimal_layout,
    },
  });

  const postHref = postsPath({ spaceSlug: post?.space_slug, slug: post?.slug });

  const onChange = sharePostDataToUpdate => {
    setFormData(prev => {
      const prevPostData = {
        post: {
          ...prev.post,
          ...sharePostDataToUpdate,
        },
      };
      getSharePostLink({ postId: post?.id, body: prevPostData });
      return prevPostData;
    });
  };

  useEffect(() => {
    if (post.share_post_enabled && !sharePostData) {
      getSharePostLink({ postId: post?.id, body: formData });
    }
  }, [
    post?.share_post_enabled,
    sharePostData,
    formData,
    getSharePostLink,
    post?.id,
  ]);

  const onClickCopyLink = link => {
    copyToClipboard(link || window.location.origin + postHref);
    success(t("post.share.link_copied"), {
      duration: "short",
      shouldUseProgress: false,
    });
  };

  return {
    onClickCopyLink,
    onChange,
    formData,
    currentCommunity,
    currentSpace,
  };
};
